import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import { JIRA_PORTAL_CAPABILITIES, type JiraPortalCapability } from "@Helpers";
import type { JiraControllerResponse, SupportAccessResponse } from "@ServerTypes/jira/jira.schema";

export const jiraTicketsUrl = `${getBackendUrl()}/jira/jiraController`;

export type SupportAccess = { isWhiteListed: boolean; capabilities: JiraPortalCapability[] };

export async function fetchSupportAccess(): Promise<SupportAccess> {
  const res = await axiosWrapper.get<SupportAccessResponse>(`${getBackendUrl()}/jira/supportAccess`);
  return { isWhiteListed: Boolean(res.data?.isWhiteListed), capabilities: res.data?.capabilities ?? [] };
}

export const hasCapability = (access: SupportAccess | null, capability: JiraPortalCapability): boolean =>
  Boolean(access?.capabilities?.includes(capability));

export const canViewSlaWith = (access: SupportAccess | null): boolean =>
  Boolean(access?.isWhiteListed) || hasCapability(access, JIRA_PORTAL_CAPABILITIES.SLA_VIEW);

export async function jiraController(data: any) {
  const res = await axiosWrapper.post<JiraControllerResponse>(`${getBackendUrl()}/jira/jiraController`, data);
  return res;
}
